import { HttpClient, HttpContext, HttpContextToken, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry, throwError } from 'rxjs';
import { CSTokenResponse } from '../../models/cstoken-response';
import { environment } from '../../../../../environments/environment';
import { AppSessions } from '../../models/app-sessions';

export const SKIP_API_TOKEN_REFRESH = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class ControlSystemsService {

  constructor(private http: HttpClient) { }


  postControlSystemsToken(id: string, appId: string, microsoftAccessToken: string): Observable<CSTokenResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${microsoftAccessToken}`
    });

    return this.http
      .post<CSTokenResponse>(`${environment.engtoolapi}/api/${id}/ControlSystemsApps/${appId}/GetCSAppToken`, {}, {
        headers,
        context: new HttpContext().set(SKIP_API_TOKEN_REFRESH, true)
      })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }
  getAppSessions(id: string): Observable<AppSessions> {

    return this.http
      .get<AppSessions>(`${environment.engtoolapi}/api/AppSessions/${id}`,)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}` +
        `error: ${error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      error);

  }
}
